// Messages for the reasons that the Sage Business Cloud Accounting connect can fail with.
const SAGE_CONNECT_ERRORS = {
  SAGE_ACCESS_DENIED: 'Access to Sage was not given. Please try again and allow Chaser to access Sage.',
  CONNECT_SESSION_EXPIRED: 'The Sage connection timed out. Please try to connect again.',
  TOKEN_EXCHANGE_FAILED: 'Chaser could not sign in to Sage. Please try to connect again.',
  TOKEN_RENEW_FAILED: 'The Sage connection timed out. Please try to connect again.',
  BUSINESSES_LOOKUP_FAILED: 'Chaser could not get your businesses from Sage. Please try again.',
  NO_BUSINESSES: 'Your Sage account has no businesses that Chaser can connect to.',
  FETCH_BUSINESS_FAILED: 'Chaser could not get the business details from Sage. Please try again.',
  SAGE_REQUESTED_ORG_MISMATCH:
    'This Sage login does not have access to the organisation you are reconnecting. Please sign in with the correct Sage login.',
  SAGE_REQUESTED_ORG_NOT_LINKED: 'You do not have access to the organisation you are reconnecting.',
  PENDING_CONNECT_NOT_FOUND: 'The Sage connection timed out. Please try to connect again.',
  PENDING_CONNECT_ALREADY_USED: 'This Sage connection was already used. Please try to connect again.',
  BUSINESS_NOT_AVAILABLE: 'The selected business is not available. Please try to connect again.',
  ALREADY_UPDATING: 'This organisation is syncing now. Please try again in a few minutes.',
};

const SAGE_CONNECT_DEFAULT_ERROR = 'Sorry, Chaser could not connect to Sage. Please try again.';

function getSageConnectErrorMessage(reason) {
  return SAGE_CONNECT_ERRORS[reason] || SAGE_CONNECT_DEFAULT_ERROR;
}

export { SAGE_CONNECT_ERRORS, SAGE_CONNECT_DEFAULT_ERROR, getSageConnectErrorMessage };
